import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import RevertIcon from 'icons/Revert.icon';
import { useTranslation } from 'react-i18next';

import './UndoButton.styles.scss';

type UndoButtonProps = {
  className?: string;
  disabled?: boolean;
  onUndo: () => void;
};

const UndoButton: React.FC<UndoButtonProps> = (props) => {
  const { className, disabled = false, onUndo } = props;

  const classes = classNames('undo-button', className);

  const { t } = useTranslation();

  return (
    <Button
      className={classes}
      variant="link"
      icon={RevertIcon}
      disabled={disabled}
      onClick={onUndo}
    >
      {t('undo')}
    </Button>
  );
};

export default UndoButton;
